import React from 'react';
import cx from 'classnames';

import styles from './DescriptionBox.module.scss';

interface Props {
  className?: string;
  width?: string;
  title: string;
  value: number | string;
}

const DescriptionBox = (props: Props) => {
  const { className, width, title, value } = props;
  return (
    <div className={cx(styles.DescriptionBox, className)} style={{ width: width }}>
      <p className={styles.desc}>{title}</p>
      <p className={styles.currency}>{value}</p>
    </div>
  );
};

export default DescriptionBox;
